import DataTable, { Column } from "../../components/DataTable";
import Tag from "../../components/Tags";
import { Invoice } from "../../types/feesAndPaymentType";
import { formatDateTime } from "../../util/functions/UniversalFunctions";

interface RecurringInvoiceProps {
  data: Invoice[];
}

export default function RecurringInvoice({ data }: RecurringInvoiceProps) {
  const columns: Column<Invoice>[] = [
    { label: "SL NO.", accessor: "invoiceId" },
    {
      label: "Invoice Number",
      accessor: "invoiceNumber",
      searchable: true,
      render: (item) => <div className="text-[13px]">{item.invoiceId}</div>,
    },
    {
      label: "Student Name",
      accessor: "studentName",
      searchable: true,
      render: (item) => <div className="text-[13px]">{item.studentName ?? "---"}</div>,
    },
    {
      label: "Status",
      accessor: "status",
      searchable: true,
      searchType: "select",
      searchOptions: ["Sent", "Pending", "Completed"],
      render: (item) => (
        <p className="text-warning-600 font-semibold capitalize">
          {item.paymentStatus}
        </p>
      ),
    },
    {
      label: "Last Invoice Date",
      accessor: "lastInvoiceDate",
      render: (item) => (
        <div className="text-[13px]">
          {formatDateTime(item.recurringFrom)}
        </div>
      ),
    },
    {
      label: "Next Invoice Date",
      accessor: "nextInvoicedate",
      render: (item) => (
        <div className="text-[13px]">
          {formatDateTime(item.recurringTo)}
        </div>
      ),
    },
    {
      label: "Total Amount(₹)",
      accessor: "totalAmount",
      render: (item) => (
        <div className="text-neutral-400 text-sm font-bold">
          ₹ {item.amount}
        </div>
      ),
    },
    {
      label: "Action",
      accessor: "action",
      render: () => <Tag text="Stop" color="danger" />,
    },
  ];

  return (
    <div className="bg-white px-6 py-5 rounded-lg overflow-x-auto">
      <DataTable columns={columns} data={data} />
    </div>
  );
}
